module.exports = __webpack_public_path__ + "assets/1h.ed7f5351.svg";